export default {
  ERROR: Symbol('error'),
  NO_SEARCH: Symbol('noSearch'),
}
